module.exports = __webpack_public_path__ + "static/assets/579529cc3c40887f6ecc771c4b39809d.mp3";